import { t } from 'i18next';
import { PrimaryButton, TertiaryButton } from '../../modal-flows/components/Buttons';
import { Dialog, DialogButtons } from './Modal/Modal';

type Props = {
  onClosed: (confirmExport: boolean) => void;
  instancesCount: number;
};

export const ConfirmExportModal = ({ onClosed, instancesCount }: Props) => {
  return (
    <Dialog onDismiss={() => onClosed(false)} title={t('exportConfirmation.title', { instances: instancesCount })} subtitle={t('exportConfirmation.subtitle')}>
      <DialogButtons>
        <TertiaryButton onClick={() => onClosed(false)}>{t('exportConfirmation.cancel')}</TertiaryButton>
        <PrimaryButton autoFocus onClick={() => onClosed(true)}>
          {t('exportConfirmation.export')}
        </PrimaryButton>
      </DialogButtons>
    </Dialog>
  );
};
